module.exports = __webpack_public_path__ + "img/PL08113.13beceeb.png";